module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/003dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1"
    }
  }, [_vm._v("Chapter 1 Beef and Veal")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_1"
    }
  }, [_vm._v("Classic Pot Roast with Carrots and Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_2"
    }
  }, [_vm._v("Braised “Barbecue” Brisket")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_3"
    }
  }, [_vm._v("Asian-Style Short Ribs with Lacquered Carrots")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_4"
    }
  }, [_vm._v("Monday Night Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_5"
    }
  }, [_vm._v("Pub Short Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_6"
    }
  }, [_vm._v("Beef Stew with Caramelized Onions and Red Wine")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_7"
    }
  }, [_vm._v("Rich Red Cowboy Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_8"
    }
  }, [_vm._v("Stracotto")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_9"
    }
  }, [_vm._v("Veal Stew with Marsala and Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_10"
    }
  }, [_vm._v("Veal Braised in Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_11"
    }
  }, [_vm._v("Osso Buco with Capers and Lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter1#sec_12"
    }
  }, [_vm._v("Veal Paprikas")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2"
    }
  }, [_vm._v("Chapter 2 Pork and Lamb")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_13"
    }
  }, [_vm._v("Pork Stew with Tomatillos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_14"
    }
  }, [_vm._v("Carnitas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_15"
    }
  }, [_vm._v("Harvest Pork Stew with Pumpkin")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_16"
    }
  }, [_vm._v("Chili Colorado with Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_17"
    }
  }, [_vm._v("True Chili Verde")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_18"
    }
  }, [_vm._v("Ginger-Braised Spareribs with Mustard Greens")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_19"
    }
  }, [_vm._v("Braised Sausages with Lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_20"
    }
  }, [_vm._v("Spring Lamb Stew with Artichokes and Leeks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_21"
    }
  }, [_vm._v("Oven-Braised Lamb Shanks with White Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_22"
    }
  }, [_vm._v("Moroccan Lamb Tagine with Preserved Lemons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_23"
    }
  }, [_vm._v("Pappardelle with Ragù")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_24"
    }
  }, [_vm._v("Greek Lamb Meatballs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter2#sec_25"
    }
  }, [_vm._v("Southern-Style Greens with Ham")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3"
    }
  }, [_vm._v("Chapter 3 Poultry")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_26"
    }
  }, [_vm._v("White Wine Coq au Vin")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_27"
    }
  }, [_vm._v("Chicken Bouillabaisse with Garlicky Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_28"
    }
  }, [_vm._v("Winter Market Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_29"
    }
  }, [_vm._v("Chicken with Escarole, Lemon, and Olives")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_30"
    }
  }, [_vm._v("Spicy Coconut-Chicken Curry")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_31"
    }
  }, [_vm._v("Tuscan Chicken Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_32"
    }
  }, [_vm._v("Sara’s Persian Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_33"
    }
  }, [_vm._v("Chicken Cacciatore")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_34"
    }
  }, [_vm._v("Turkey Posole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_35"
    }
  }, [_vm._v("Turkey Pot Pie in a Pan")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter3#sec_36"
    }
  }, [_vm._v("Game Hens in a Pot")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4"
    }
  }, [_vm._v("Chapter 4 Fish and Shellfish")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4#sec_37"
    }
  }, [_vm._v("Shortcut Bouillabaisse")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4#sec_38"
    }
  }, [_vm._v("Summer Stew with Halibut")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4#sec_39"
    }
  }, [_vm._v("Salmon Ragout with Tarragon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4#sec_40"
    }
  }, [_vm._v("Sicilian Swordfish Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4#sec_41"
    }
  }, [_vm._v("Thai Fish and Corn Curry")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4#sec_42"
    }
  }, [_vm._v("Greek Shrimp with Zucchini and Feta")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4#sec_43"
    }
  }, [_vm._v("Red-Braised Shrimp and Tofu with Bok Choy")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4#sec_44"
    }
  }, [_vm._v("Portuguese Clam and Sausage Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter4#sec_45"
    }
  }, [_vm._v("Spanish Scallops")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5"
    }
  }, [_vm._v("Chapter 5 Vegetables")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_46"
    }
  }, [_vm._v("Vegetable Couscous")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_47"
    }
  }, [_vm._v("Indian Cauliflower and Potato Curry")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_48"
    }
  }, [_vm._v("Cipollini in Honey and Balsamic")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_49"
    }
  }, [_vm._v("Braised Stuffed Cabbage")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_50"
    }
  }, [_vm._v("Swiss Chard with Cannellini")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_51"
    }
  }, [_vm._v("Braised Escarole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_52"
    }
  }, [_vm._v("Bean and Corn Stew with Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_53"
    }
  }, [_vm._v("Braised Borlotti Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_54"
    }
  }, [_vm._v("Tomato-Braised Romano Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_55"
    }
  }, [_vm._v("Butter-Braised Lettuce with Fresh Peas and Thyme")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_56"
    }
  }, [_vm._v("Pan-Braised Endive with Crusty Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_57"
    }
  }, [_vm._v("Slow-Cooked Green Beans with Dill")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter5#sec_58"
    }
  }, [_vm._v("Spring Stew of Favas, Artichokes, and Fresh Peas (La Vignarola)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6"
    }
  }, [_vm._v("Chapter 6 Accompaniments")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_59"
    }
  }, [_vm._v("Apricot Couscous")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_60"
    }
  }, [_vm._v("Creamy Baked Polenta")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_61"
    }
  }, [_vm._v("Golden Pilaf")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_62"
    }
  }, [_vm._v("Farrotto")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_63"
    }
  }, [_vm._v("Herbed Wide Noodles")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_64"
    }
  }, [_vm._v("Shortcut Risotto")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_65"
    }
  }, [_vm._v("Cheddar Mashers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_66"
    }
  }, [_vm._v("Naneita’s Coleslaw")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_67"
    }
  }, [_vm._v("Romesco Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_68"
    }
  }, [_vm._v("Horseradish Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_69"
    }
  }, [_vm._v("Yogurt-Mint Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_70"
    }
  }, [_vm._v("Kat Daddy’s Pepper Vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_71"
    }
  }, [_vm._v("Lemon-Rosemary Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_72"
    }
  }, [_vm._v("Basil Gremolata")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter6#sec_73"
    }
  }, [_vm._v("Preserved Lemons")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sug"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012suggestedpairings"
    }
  }, [_vm._v("Suggested Pairings: Braises and Stews and Accompaniments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "index"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "table"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014table"
    }
  }, [_vm._v("Table of equivalents")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/015abouttheauthor"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/016copyright"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0b6322c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004-toc.vue
// module id = 66
// module chunks = 0